import {useContext} from 'react';
import {SidebarMenuButtonContext} from './SidebarMenuButtonContext';

export function useSidebarMenuButton() {
  return useContext(SidebarMenuButtonContext);
}
